import React from 'react';
import './SummaryCards.css';

const statusConfig = {
  'on-track': { label: 'On Track', color: '#22c55e', bg: 'rgba(34, 197, 94, 0.08)' },
  'needs-attention': { label: 'Needs Attention', color: '#f59e0b', bg: 'rgba(245, 158, 11, 0.08)' },
  'at-risk': { label: 'At Risk', color: '#ef4444', bg: 'rgba(239, 68, 68, 0.08)' },
  'no-data': { label: 'No Recent Data', color: '#94a3b8', bg: 'rgba(148, 163, 184, 0.08)' },
};

export function OverallStatusCard({ status, description }) {
  const config = statusConfig[status] || statusConfig['no-data'];

  return (
    <div className="summary-card">
      <span className="summary-card__label">Overall Status</span>
      <div className="summary-card__status" style={{ color: config.color, background: config.bg }}>
        <span className="summary-card__status-dot" style={{ background: config.color }} />
        {config.label}
      </div>
      {description && <span className="summary-card__description">{description}</span>}
    </div>
  );
}

export function AssignmentCompletionCard({ completed, total, changeFromLastWeek }) {
  const percentage = total > 0 ? Math.round((completed / total) * 100) : 0;
  const changeLabel = changeFromLastWeek > 0
    ? `+${changeFromLastWeek}% from last week`
    : changeFromLastWeek < 0
    ? `${changeFromLastWeek}% from last week`
    : 'Same as last week';

  return (
    <div className="summary-card">
      <span className="summary-card__label">Assignment Completion</span>
      <div className="summary-card__value">{percentage}%</div>
      <span className="summary-card__subtext">{completed} of {total} completed</span>
      <span className={`summary-card__change ${changeFromLastWeek >= 0 ? 'summary-card__change--positive' : 'summary-card__change--negative'}`}>
        {changeLabel}
      </span>
    </div>
  );
}

export function UpcomingWorkCard({ dueThisWeek, overdue, nextDeadline }) {
  return (
    <div className="summary-card">
      <span className="summary-card__label">Upcoming Work</span>
      <div className="summary-card__value">{dueThisWeek}</div>
      <span className="summary-card__subtext">due this week</span>
      <div className="summary-card__details">
        {overdue > 0 && (
          <span className="summary-card__detail summary-card__detail--warning">
            {overdue} overdue
          </span>
        )}
        {nextDeadline && (
          <span className="summary-card__detail">
            Next: {nextDeadline}
          </span>
        )}
      </div>
    </div>
  );
}

export function StudyEngagementCard({ activeDays, quizzes, flashcardSessions, conversations, notes }) {
  return (
    <div className="summary-card">
      <span className="summary-card__label">Study Engagement</span>
      <div className="summary-card__value">{activeDays} <span className="summary-card__unit">active days</span></div>
      <div className="summary-card__metrics">
        <span className="summary-card__metric">{quizzes} quizzes</span>
        <span className="summary-card__metric">{flashcardSessions} flashcard sessions</span>
        <span className="summary-card__metric">{conversations} conversations</span>
        <span className="summary-card__metric">{notes} notes</span>
      </div>
    </div>
  );
}
